<template>
    <div class="login-wrap">
        <div class="ms-login">
            <div class="ms-title">臣邦医药后台管理系统</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="mobile">
                    <el-input v-model="param.mobile" placeholder="请输入手机号" @keyup.enter.native="submitForm('login')">
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input type="password" placeholder="请输入密码" v-model="param.password" @keyup.enter.native="submitForm('login')">
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div style="text-align: right;">
                    <el-link class="forget-password" @click="handleClick()">忘记密码 </el-link>
                </div>
                <div class="login-btn">
                    <el-button type="primary" :loading="loading" @keyup.enter.native="submitForm('login')" @click="submitForm('login')"
                        >登 录</el-button
                    >
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'login',
    data: function () {
        return {
            param: {
                mobile: '',
                password: ''
            },
            rules: {
                mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            },
            loading: false
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$api
                        .login(this.param)
                        .then((res) => {
                            this.loading = false;
                            if (res.code === 0) {
                                localStorage.setItem('adminToken', res.data.token);
                                localStorage.setItem('adminMenus', JSON.stringify(res.data.menus));
                                localStorage.setItem('adminRoutes', JSON.stringify(res.data.routes));
                                localStorage.setItem('dataList', JSON.stringify(res.data.fields));
                                localStorage.setItem('detailList', JSON.stringify(res.data.fields_detail));
                                localStorage.setItem('roles', JSON.stringify(res.data.roles));
                                var paramsList = {};
                                localStorage.setItem('paramsList', JSON.stringify(paramsList));
                                localStorage.setItem('adminName', res.data.name);
                                localStorage.setItem('adminCode', res.data.code);

                                this.$message({
                                    message: '登录成功',
                                    type: 'success'
                                });
                                this.$router.replace({ path: '/dashboard' });
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        handleClick() {
            this.$router.push({
                path: '/forget',
                query: {}
            });
        }
    }
};
</script>

<style scoped>
.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/login-bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: rgb(80, 80, 80);
    background: rgba(255, 255, 255, 0.3);
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    /* background-image: -webkit-gradient(linear, left 0, right 0, from(rgb(248, 97, 10)), to(rgb(58, 6, 248)));
    -webkit-background-clip: text;/*必需加前缀 -webkit- 才支持这个text值 */
    /* background-clip: text; */
    /* -webkit-text-fill-color: transparent;text-fill-color会覆盖color所定义的字体颜色： */
    font-weight: bold;
}
.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.forget-password {
    font-size: 12px;
    color: #409eff;
    margin-bottom: 14px;
    margin-right: 4px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}
.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}
</style>